import React, { useState, useCallback, useEffect } from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from 'bignumber.js'

// utils
import { getRandom } from '../../../utils/func'
import { BIGNUMBER_FMT } from '../../../constants/bakery'
import { PetProps } from '../../../constants/pets'

// components
import ArtworkBtn from '../../../components/nftInfo/button/ArtworkBtn'
import FlagStatus from '../../../components/nftInfo/FlagStatus'

// hooks
import { useActiveWeb3React } from '../../../hooks'
import { MARKETTYPE, MARKETTYPEV1, MARKETTYPEV3, SUPPORTTYPE } from '../../../constants/bakery/nft'

import useUserBids from '../../../hooks/nft/useUserBids'
import useUserAsks from '../../../hooks/nft/useUserAsks'

const EggCard = styled.div<{backgroundColor: string, backgroundImageX: number, backgroundImageY: number}>`
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: 447px 372px;
  background-color: ${({ backgroundColor, theme }) => backgroundColor ? backgroundColor : theme.bsBg18};
  background-position: ${({ backgroundImageX }) => backgroundImageX ? backgroundImageX : 0}px ${({ backgroundImageY }) => backgroundImageY ? backgroundImageY : 0}px;
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  border-radius: 28px;
  width: 281px;
  height: 470px;
  margin-bottom: 25px;
  margin-right: 12px;
  margin-left: 12px;
`
const PetName = styled.div<{color?: string}>`
  display: flex;
  justify-content: center;
  height: 27px;
  color: ${({color }) => color ? color : '#AC562A'};
  font-weight: 700;
  margin: 4px 20px 0;
  font-family: Baloo Da;
  letter-spacing: 1px;
`
const PetBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(/images/petsNft/ellipse_shadow.svg);
  background-repeat: no-repeat;
  background-position: bottom 0px center;
  background-size: 152px auto;
  width: 100%;
  height: 226px;
`
const IconEgg = styled.img`
  margin-top: 20px;
  width: auto;
  height: 200px;
`
const CardHead = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  text-align: center;
`
const CardFoot = styled.div<{bg?:string}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({bg, theme }) => bg ? bg : theme.bsBg3};
  border-bottom-left-radius: 28px;
  border-bottom-right-radius: 28px;
  padding-bottom: 16px;
  padding-top: 6px;
  height: 210px;
  overflow: hidden;
  z-index: 1;
`
const PetLevel = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #FFFDFA;
  width: 100%;
  text-align: center;
  padding: 7px 16px 0;
  white-space: nowrap;
`

export default function Egg({egg, isMyEgg, bakeBalance = 0, allowanceBuy, allowanceSellAll}: {egg: PetProps, isMyEgg?: boolean, bakeBalance?: number, allowanceBuy?: BigNumber, allowanceSellAll?: boolean}) {
  const [backgroundImageX] = useState(Math.floor(getRandom(0, 237) * -1))
  const [backgroundImageY] = useState(Math.floor(getRandom(0, 140) * -1))

  const { account } = useActiveWeb3React()


  let marketType = ''
  if (egg.level === 'v1') {
    marketType = MARKETTYPEV1.PETNFTV1
  } else if (egg.level === 'v2') {
    marketType = MARKETTYPE.PETNFT
  } else if (egg.level === 'v3') {
    marketType = MARKETTYPEV3.PETNFTV3
  }

  // 获取我的竞价
  const getBids = useUserBids(marketType)
  const emptyBids: any[] = []
  const [ids, setIds] = useState(emptyBids)
  const getIds = useCallback(async() => {
    const bids = await getBids()
    if (bids.length) {
      const bidsId = bids.map((d: any) => {
        return d[0]
      })
      setIds(bidsId)
    }
  }, [getBids])

  // 获取我的挂单
  const getAsks = useUserAsks(marketType)
  const emptyAsks: any[] = []
  const [aksIds, setAskIds] = useState(emptyAsks)
  const getAskIds = useCallback(async() => {
    const asks = await getAsks()
    if (asks.length) {
      const asksId = asks.map((d: any) => {
        return d[0]
      })
      setAskIds(asksId)
    }
  }, [getAsks])

  useEffect(() => {
    if (account) {
      getAskIds()
      getIds()
    }
  }, [getBids, getIds, getAskIds, getAsks, account, egg])

  return (
    <EggCard backgroundColor={egg.level === 'v3' || isMyEgg ? '' : '#DEDEDE'} backgroundImageX={backgroundImageX} backgroundImageY={backgroundImageY}>
      <CardHead>
        <FlagStatus artwork={egg} ids={ids} isMyArtwork={isMyEgg}  />
        <PetBox>
          <IconEgg src={ egg.petUrl } />
        </PetBox>
        <PetName color={egg.level === 'v3' || isMyEgg ? '' : '#776D63'}>
          <Text>#{egg.tokenId} {egg.name}</Text>
        </PetName>
      </CardHead>
      <CardFoot bg={egg.level === 'v3' || isMyEgg ? '' : '#DEDEDE'} >
        <PetLevel>
          <Text fontSize={14}>Battle Power: </Text>
          <Text fontSize={16} fontWeight={700}>{new BigNumber(egg.battlePower).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)}</Text>
        </PetLevel>
        <PetLevel>
          <Text fontSize={14}>PET to get after abandon: </Text>
          <Text fontSize={16} fontWeight={700}>{new BigNumber(egg.petToGet).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)}</Text>
        </PetLevel>
        <PetLevel>
          <Text fontSize={14}>BAKE to get after abandon: </Text>
          <Text fontSize={16} fontWeight={700}>{new BigNumber(egg.bakeToGet).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)}</Text>
        </PetLevel>
        <PetLevel style={{margin: '15px 0 8px'}}>
          <Text fontSize={14}>Price(BAKE):</Text>
          <Text fontSize={20} fontWeight={700}>{egg.price ? new BigNumber(!egg.auctionPrice ? egg.price : egg.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) : '-'}</Text>
        </PetLevel>
        <PetLevel>
          <ArtworkBtn
            artwork={egg}
            status={1}
            isMyArtwork={isMyEgg}
            ids={ids}
            myAksIds={aksIds}
            marketType={marketType}
            symbol={SUPPORTTYPE.BAKE}
          />
        </PetLevel>

      </CardFoot>
    </EggCard>
  )
}
